(function () {
  function init(root) {
    if (!root || root.dataset.ready === '1') return;
    root.dataset.ready = '1';
    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var variants = [];
    try { variants = JSON.parse(q('[data-variants]').textContent); } catch (e) {}
    var ci = parseInt(root.dataset.ci, 10), si = parseInt(root.dataset.si, 10);
    var giftId = parseInt(root.dataset.gift, 10);
    var cta = root.dataset.cta;
    var color = root.dataset.color0, size = root.dataset.size0, bundle = 1;
    function find(c, s) {
      return variants.find(function (v) {
        return (ci < 0 || v.options[ci] === c) && (si < 0 || v.options[si] === s);
      });
    }

    // Galerie
    var track = q('[data-track]');
    var thumbs = qa('[data-thumb]');
    function slideTo(i) { if (track) track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { slideTo(i); }); });
    if (track) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
        var c = q('[data-count]'); if (c) c.textContent = (i + 1) + ' / ' + track.children.length;
      }, { passive: true });
    }

    var btn = q('[data-add]'), lbl = q('[data-add-label]'), err = q('[data-err]');
    function refresh(colorChanged) {
      var v = find(color, size);
      var cl = q('[data-color-label]'); if (cl) cl.textContent = color;
      var sl = q('[data-size-label]'); if (sl) sl.textContent = size;
      qa('[data-color]').forEach(function (b) { b.classList.toggle('is-on', b.dataset.color === color); b.setAttribute('aria-pressed', b.dataset.color === color); });
      qa('[data-size]').forEach(function (b) {
        var vv = find(color, b.dataset.size);
        b.classList.toggle('is-on', b.dataset.size === size);
        b.classList.toggle('is-out', !vv || !vv.available);
        b.setAttribute('aria-pressed', b.dataset.size === size);
      });
      var ok = !!(v && v.available);
      btn.disabled = !ok;
      lbl.textContent = ok ? cta : 'Épuisé';
      if (colorChanged && v && v.featured_image) {
        var first = q('[data-first-img]');
        if (first) { first.removeAttribute('srcset'); first.src = v.featured_image.src; slideTo(0); }
      }
    }
    qa('[data-color]').forEach(function (b) { b.addEventListener('click', function () { color = b.dataset.color; refresh(true); }); });
    qa('[data-size]').forEach(function (b) { b.addEventListener('click', function () { size = b.dataset.size; refresh(false); }); });

    // Offres
    var price = q('[data-price]'), compare = q('[data-compare]'), save = q('[data-save]'), sp = q('[data-sticky-price]');
    function setBundle(label) {
      var input = label.querySelector('input');
      bundle = parseInt(input.value, 10);
      input.checked = true;
      qa('[data-bundle]').forEach(function (x) { x.classList.toggle('is-on', x === label); });
      var xr = q('[data-extra]'); if (xr) xr.hidden = bundle < 2;
      qa('[data-extra-row]').forEach(function (r) {
        var n = parseInt(r.dataset.extraRow, 10);
        r.hidden = n > bundle;
        if (!r.dataset.touched) {
          r.querySelector('[data-x-color]').value = color;
          var xs = r.querySelector('[data-x-size]'); if (xs) xs.value = size;
        }
      });
      price.textContent = label.dataset.price;
      compare.textContent = label.dataset.compare || '';
      save.textContent = label.dataset.save || '';
      if (sp) sp.textContent = label.dataset.price;
    }
    qa('[data-bundle]').forEach(function (l) { l.querySelector('input').addEventListener('change', function () { setBundle(l); }); });
    qa('[data-extra-row] select').forEach(function (s) { s.addEventListener('change', function () { s.closest('[data-extra-row]').dataset.touched = '1'; }); });
    var bp = new URLSearchParams(window.location.search).get('bundle');
    if (bp) { var bl = q('[data-bundle="' + bp + '"]'); if (bl) setBundle(bl); }

    // Ajout au panier
    btn.addEventListener('click', function () {
      err.hidden = true;
      var v = find(color, size);
      if (!v || !v.available) return;
      var ids = [v.id];
      var bad = false;
      qa('[data-extra-row]').forEach(function (r) {
        if (parseInt(r.dataset.extraRow, 10) > bundle) return;
        var xs = r.querySelector('[data-x-size]');
        var vx = find(r.querySelector('[data-x-color]').value, xs ? xs.value : size);
        if (!vx || !vx.available) { bad = true; return; }
        ids.push(vx.id);
      });
      if (bad) { err.textContent = 'Une des robes choisies est épuisée dans cette taille. Choisis une autre taille ou couleur.'; err.hidden = false; return; }
      var counts = {};
      ids.forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
      var items = Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
      if (bundle >= 2 && giftId) items.push({ id: giftId, quantity: 1 });
      btn.disabled = true; lbl.textContent = 'Ajout en cours…';
      var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        window.location.href = root.dataset.cart;
      }).catch(function (e) {
        err.textContent = (e && e.description) || 'Une erreur est survenue, réessaie.';
        err.hidden = false; btn.disabled = false; lbl.textContent = cta;
      });
    });

    // Avant / après
    qa('[data-ba]').forEach(function (ba) {
      var r = ba.querySelector('input');
      r.addEventListener('input', function () { ba.style.setProperty('--pos', r.value + '%'); });
    });

    // Barre d'achat collante (mobile)
    var sticky = q('[data-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0];
        sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(btn);
    }
    qa('[data-to-buy]').forEach(function (b) {
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        var t = q('[data-buy]'); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    refresh(false);
  }
  function all() { document.querySelectorAll('[data-mp-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-mp-pdp]'); if (r) { r.dataset.ready = '0'; init(r); }
  });
})();